var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary mx-1 rounded-pill",on:{"click":_vm.exportUsers}},[_vm._v("خروجی از کاربران")])
}
var staticRenderFns = []

export { render, staticRenderFns }